module.exports = __webpack_public_path__ + "static/media/galerija_2016 (9).194922f8.jpg";